// REACT
import React, { Component } from "react";
import firebase from "firebase/app";
import { withRouter } from "react-router-dom";
// REDUX
import { connect } from "react-redux";
import { emptyToken } from "../../Actions/apiActions";
import { emptyFilter } from "../../Actions/searchActions";
import {
  signOut,
  removeFirebaseListener,
  setLanguage,
  getDataForStatistics,
} from "../../Actions/firebaseActions";
// COMPONENTS
import Paper from "@material-ui/core/Paper";
import Header from "../Presentation/Header/Header";
import Profile from "../Presentation/Profile/Profile";
import PartnerFooter from "../Presentation/PartnerFooter/PartnerFooter";

class ProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: "",
    };
  }

  OnLogoutClick = () => {
    firebase.auth().signOut();
    if (this.props.listenerActive) {
      this.props.removeFirebaseListener();
    }
    this.props.signOut();
    this.props.emptyToken();
    this.props.emptyFilter();
    this.props.history.push("/");
  };

  updatePassword = (newPassword) => {
    let componentState = this;
    firebase
      .auth()
      .currentUser.updatePassword(newPassword)
      .then(function () {
        componentState.setState({ errorText: "Password Updated" });
        console.log(componentState.state.errorMsg);
      })
      .catch(function (error) {
        componentState.setState({ errorText: error.message });
        console.log(componentState.state.errorMsg);
      });
  };

  updateLanguage = (language) => {
    this.props.setLanguage(this.props.username, language);
  };

  OnBackClick = () => {
    this.props.history.push("/MainScreen");
  };

  render() {
    return (
      <div className="ProfileScreen">
        <Header
          isLoggedIn={true}
          onFeedBackClick={this.onFeedBackClick}
          currentUser={this.props.username}
          language={this.props.language}
          showBackBtn={true}
        />
        <div
          className="container-fluid col-lg-8 col-md-11 col-sm-11"
          style={{ marginTop: "85px" }}
        >
          <Paper
            elevation={6}
            style={{
              marginTop: "3vh",
              paddingTop: "15px",
              paddingBottom: "10px",
              borderRadius: "8px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            <Profile
              email={this.props.email}
              username={this.props.username}
              OnLogoutClick={this.OnLogoutClick}
              OnBackClick={this.OnBackClick}
              updatePassword={this.updatePassword}
              errorText={this.state.errorText}
              language={this.props.language}
              inventory={this.props.inventory}
              updateLanguage={this.updateLanguage}
              getDataForStatistics={this.props.getDataForStatistics}
              history={this.props.history}
            />
          </Paper>
        </div>
        <PartnerFooter language={this.props.language} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.firebase.username,
  email: state.firebase.email,
  language: state.firebase.language,
  inventory: state.firebase.inventory,
  listenerActive: state.firebase.listenerActive,
  reportData: state.firebase.reportData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    emptyToken: () => dispatch(emptyToken()),
    emptyFilter: () => dispatch(emptyFilter()),
    signOut: () => dispatch(signOut()),
    removeFirebaseListener: () => dispatch(removeFirebaseListener()),
    setLanguage: (uid, language) => dispatch(setLanguage(uid, language)),
    getDataForStatistics: (uid) => dispatch(getDataForStatistics(uid)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProfileScreen)
);
